import {
  Dialog,
  DialogContent,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { PencilLine } from "@phosphor-icons/react";
import { useState } from "react";
import { theme } from "../../../theme";
import { FormRegisterPerson } from "../FormRegisterPerson/FormRegisterPerson";

export const EditPerson = ({ data }) => {
  const [open, setOpen] = useState(false);
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <IconButton
        sx={{
          backgroundColor: theme.palette.primary.main,
          margin: theme.spacing(0, 2),
          height: 45,
        }}
        onClick={() => setOpen(true)}
      >
        <PencilLine color={theme.palette.primary.secondary} size={32} />
      </IconButton>

      <Dialog
        open={open}
        fullScreen={isSmall}
        fullWidth
        onClose={() => setOpen(false)}
      >
        <DialogContent>
          <FormRegisterPerson edit data={data} close={() => setOpen(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
};
